import React, { createContext, useContext } from "react";
import { useToasterService } from "../services/toaster.service";


let operationsAllowed: any = {};
const ToasterFacadeContext = createContext(operationsAllowed);

export const ToasterFacadeProvider = (props: any) => {

  const toasterService = useToasterService();

  const showError = (message: string) => {
    toasterService.showError(message);
  }

  const showWarning = (message: string) => {
    toasterService.showWarning(message);
  }

  const showInfo = (message: string) => {
    toasterService.showInfo(message);
  }

  const showSuccess = (message: string) => {
    toasterService.showSuccess(message);
  }

  operationsAllowed = {
    showError,
    showWarning,
    showInfo,
    showSuccess
  };

  return (
    <ToasterFacadeContext.Provider value={operationsAllowed}>
      {props.children}
    </ToasterFacadeContext.Provider>
  );
}

export const useToasterFacade = () => {
  return useContext(ToasterFacadeContext);
}